// export const AWS_CONFIG = {
//   region: "ap-south-1",
//   credentials: {
//     accessKeyId: "AKIAZ627Y36VZXQMRSGG",
//     secretAccessKey: "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",
//   }
// }; 

// ikan aira
export const AWS_CONFIG = {
  region: "ap-south-1",
  credentials: {
    accessKeyId: "AKIAR5JBBV4WNWE6R776",
    secretAccessKey: "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",
  }
}; 